import { createSlice } from "@reduxjs/toolkit";
import {
  createTenantAction,
  getTenantsAction,
  getTenantByIdAction,
  updateTenantAction,
  deleteTenantAction,
} from "../../actions/tenants/tenantAction";

const initialState = {
  tenants: [],
  loading: false,
  createLoading: false,
  createSuccess: false,
  createError: null,
  updateLoading: false,
  updateSuccess: false,
  updateError: null,
  deleteLoading: false,
  deleteSuccess: false,
  deleteError: null,
  hasFetched: false,
  deleteSubLoading: false,
  deleteSubSuccess: false,
  deleteSubError: null,
};

const tenantslice = createSlice({
  name: "tenants",
  initialState,
  reducers: {
    resetTenantFlags: (state) => {
      state.createSuccess = false;
      state.createError = null;
      state.updateSuccess = false;
      state.updateError = null;
      state.deleteSuccess = false;
      state.deleteError = null;
      state.deleteSubSuccess = false;
      state.deleteSubError = null;
    },
    updateLocalTenants: (state, action) => {
      const tenants = Array.isArray(action.payload) ? action.payload : [action.payload];
      tenants.forEach((tenant) => {
        if (tenant && typeof tenant === "object" && tenant.tenantID) {
          const index = state.tenants.findIndex((t) => t.tenantID === tenant.tenantID);
          if (index !== -1) {
            state.tenants[index] = tenant;
          } else {
            state.tenants.push(tenant);
          }
        }
      });
    },
    removeLocalTenant: (state, action) => {
      state.tenants = state.tenants.filter((t) => t.tenantID !== action.payload);
    },
    setHasFetched: (state) => {
      state.hasFetched = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTenantAction.pending, (state) => {
        state.createLoading = true;
        state.createSuccess = false;
        state.createError = null;
      })
      .addCase(createTenantAction.fulfilled, (state, action) => {
        state.createLoading = false;
        state.createSuccess = true;
        const newTenant = action.payload;
        if (newTenant && typeof newTenant === "object" && newTenant.tenantID) {
          const index = state.tenants.findIndex((t) => t.tenantID === newTenant.tenantID);
          if (index === -1) {
            state.tenants.push(newTenant);
          }
        }
        state.hasFetched = false;
      })
      .addCase(createTenantAction.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload;
      })
      // .addCase(getTenantsAction.pending, (state) => {
      //   state.loading = true;
      // })
      .addCase(getTenantsAction.pending, (state) => {
  state.loading = true;
})
      // .addCase(getTenantsAction.fulfilled, (state, action) => {
      //   state.loading = false;
      //   // const tenants = action.payload || [];
      //   const tenants = Array.isArray(action.payload) ? action.payload : [];
      //   const validTenants = tenants.filter((t) => t && typeof t === "object" && t.tenantID);
      //   state.tenants = validTenants;
      //   state.hasFetched = true;
      // })
      .addCase(getTenantsAction.fulfilled, (state, action) => {
  state.loading = false;
  // return data;
  // return Array.isArray(data) ? data : [];
  const tenants = Array.isArray(action.payload) ? action.payload : [];
  const validTenants = tenants.filter((t) => t && typeof t === "object" && t.tenantID);
  state.tenants = validTenants;
  state.hasFetched = true;
})
      // .addCase(getTenantsAction.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      //   state.tenants = [];
      //   state.hasFetched = true;
      // })
      .addCase(getTenantsAction.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
  state.tenants = [];
  state.hasFetched = true;
})
      .addCase(getTenantByIdAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTenantByIdAction.fulfilled, (state, action) => {
        state.loading = false;
        const tenant = action.payload;
        if (tenant && typeof tenant === "object" && tenant.tenantID) {
          const index = state.tenants.findIndex((t) => t.tenantID === tenant.tenantID);
          if (index !== -1) {
            state.tenants[index] = tenant;
          } else {
            state.tenants.push(tenant);
          }
        }
      })
      .addCase(getTenantByIdAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTenantAction.pending, (state) => {
        state.updateLoading = true;
        state.updateSuccess = false;
        state.updateError = null;
      })
      .addCase(updateTenantAction.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
        const updatedTenant = action.payload;
        const index = state.tenants.findIndex((t) => t.tenantID === updatedTenant.tenantID);
        if (index !== -1) {
          state.tenants[index] = updatedTenant;
        }
        state.hasFetched = false;
      })
      .addCase(updateTenantAction.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
      })
      .addCase(deleteTenantAction.pending, (state) => {
        state.deleteLoading = true;
        state.deleteSuccess = false;
        state.deleteError = null;
      })
      .addCase(deleteTenantAction.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = true;
        state.tenants = state.tenants.filter((t) => t.tenantID !== action.payload);
      })
      .addCase(deleteTenantAction.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.payload;
      });
  },
});

export const { resetTenantFlags, updateLocalTenants, removeLocalTenant, setHasFetched } = tenantslice.actions;
export default tenantslice.reducer;